import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// import { MuiThemeProvider, createMuiTheme, CssBaseline } from '@material-ui/core';
import { Provider, useDispatch, useSelector } from 'react-redux'
import reportWebVitals from './reportWebVitals';
import { createTheme, ThemeProvider } from '@mui/material/styles'
import { store, persistor } from './redux/store';
import { PersistGate } from 'redux-persist/integration/react';
import { DefaultConfig } from './config/defaultConfig';
// import "./i18n";
import axios from 'axios';
import { fetchEnv } from './redux/actions/env.action';
import { getApiUrl } from './utils/apiUrls';
import { changeLang } from './redux/actions/appSettings.actions';
import { apiErrorHandler } from './utils/errorHandler';
import { openSnackBar } from './redux/actions/snackbar.actions';
import { InitI18Comp } from './InitI18.component';
import ProgressBar from './components/progress-bar/ProgressBar.component';
import { useSearchParams } from 'react-router-dom';
import instance from './utils/axios';
import { saveClientData } from './redux/actions/clientData.actions';
import ErrorBoundary from './components/error-boundary/ErrorBoundary.component';


const theme = createTheme({  
  typography: { fontFamily: ["Noto Sans", "sans-serif"].join(",") }
});

const root = ReactDOM.createRoot(document.getElementById('root'));

const Main = () => {
  const dispatch = useDispatch();
  const user = useSelector(state => state.user);
  const envState = useSelector(state => state.env);
  const [isLoading, setIsLoading] = React.useState(true);
  const [clientDataLoading, setClientDataLoading] = React.useState(false);

  let configToUse = DefaultConfig;

  const fetchAllLangs = async (getLang) => {
    try {
        const res = await instance.get(`${getApiUrl("getAllLanguages")}`);

        if(!!res.data) {
          const langExists = res.data.find(el => el.languageCode === getLang);

          if(!langExists) {
              const redirectLink = window.location.href.split("?")
              window.location.href = redirectLink?.length > 0 ? redirectLink[0] : '/'
          } 
          else {
            setIsLoading(false)
          }
        }

    } catch (error) {
        const msgObj = apiErrorHandler(error);
        dispatch(
            openSnackBar({
                msg: msgObj?.statusText,
                type: "error",
            })
        );
    }
}

  const checkLangPresent = () => {
    var url = new URL(window.location.href);
    const getLang = url.searchParams.get('lang');

    if(!user && !!getLang) {
      fetchAllLangs(getLang)
    } else {
      setIsLoading(false)
    }
  }

  const fetchConfig = async() => {
    try {
        const res = await axios.get(`/env`);

        if(!!res.data) {
          configToUse = res.data;

          if(res.data?.RECAPTCHA?.USE_RECAPTCHA_NET) {
            window.recaptchaOptions = {
              useRecaptchaNet: true,
            }
            console.log("Set recaptchaOptions to useRecaptchaNet: true");
          }

          dispatch(fetchEnv(configToUse));
          checkLangPresent()
        }
    } catch (error) {
      checkLangPresent();
      dispatch(fetchEnv(configToUse));
      setIsLoading(false)
    }
  }

  const fetchClientData = async (refId) => {
    try {
        setClientDataLoading(true);
        const res = await instance.get(`${getApiUrl("getClientData")}?refId=${refId}`);

        if(!!res.data) {
          dispatch(saveClientData({ logo: res.data?.logoPath, clientName: res.data?.clientName }))
          setClientDataLoading(false);
        }
    } catch (error) {
        setClientDataLoading(false);
        const msgObj = apiErrorHandler(error);
        dispatch(
            openSnackBar({
                msg: msgObj?.statusText,
                type: "error",
            })
        );
    }
}

  React.useEffect(() => {
    fetchConfig();
    // eslint-disable-next-line
  }, []);

  React.useEffect(() => {
    if(envState && !clientDataLoading) {
      const url = new window.URL(window.location.href);
      const refId = url.searchParams.get("refId");
      if(refId) fetchClientData(refId);
    }
  }, [envState])

  React.useEffect(() => {
    if (envState !== null && !!user) {
      // getLastUsedLanguage();
    }
    // eslint-disable-next-line
  }, [envState]);

  return !isLoading && !!envState ? (
    <ThemeProvider theme={theme}>
        <InitI18Comp />
    </ThemeProvider>
  ) : <ProgressBar />

}

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          {/* <ThemeProvider theme={theme}>
            <App />
          </ThemeProvider> */}
          <Main />
        </PersistGate>
      </Provider>
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
